export class SectorFilter 
{
    HCMCovered: boolean;
    NotFullyCovered: boolean;
    Consensus: boolean;
    Credit: boolean;
    OnlyCompanies: boolean;
    LockCompanies: boolean;
}